import React from "react";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const HcaSelect = ({ id, label, value, onChange, options, testId }) => (
    <div className="space-y-1.5">
        <Label htmlFor={id} className="text-xs font-semibold text-[#0E1E3A]">{label}</Label>
        <Select value={value} onValueChange={onChange}>
            <SelectTrigger id={id} data-testid={testId} className="h-11 bg-white border-[#D8DEE6]">
                <SelectValue placeholder="Select one" />
            </SelectTrigger>
            <SelectContent>
                {options.map((o, i) => (
                    <SelectItem key={o} value={o} data-testid={`${testId}-option-${i}`}>{o}</SelectItem>
                ))}
            </SelectContent>
        </Select>
    </div>
);

export const HcaPills = ({ label, value, onChange, options, testId }) => (
    <div className="space-y-1.5">
        <span className="text-xs font-semibold text-[#0E1E3A]">{label}</span>
        <div className="flex flex-wrap gap-2" role="radiogroup" data-testid={testId}>
            {options.map((o, i) => (
                <button
                    key={o}
                    type="button"
                    role="radio"
                    aria-checked={value === o}
                    onClick={() => onChange(o)}
                    data-testid={`${testId}-option-${i}`}
                    className={`px-3.5 py-2 rounded-full text-sm border transition-colors duration-200 ${
                        value === o
                            ? "bg-[#0E1E3A] text-white border-[#0E1E3A]"
                            : "bg-white text-[#0E1E3A] border-[#D8DEE6] hover:border-[#D4A140]"
                    }`}
                >
                    {o}
                </button>
            ))}
        </div>
    </div>
);
